import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { isApiProblem } from '@ticarishift/api-client/runtime';
import { reportError } from '@ticarishift/error-tracking';
import { RouteError } from '@ticarishift/ui';

/**
 * Rota hata sınırı (08 §11.7): "Bu sayfa açılamadı"; tekrar dene ve ana sayfa. Hata bir API hatasıysa destek kodu
 * (izleme kimliğinin kısası) gösterilir; kullanıcı destek talebinde bu kodu verir. Uygulama hatası hata takibine bildirilir (S62); rota yanıtı
 * ve API hatası bildirilmez (API hataları sunucuda izlenir).
 */
export function RouteErrorBoundary() {
  const error = useRouteError();
  useEffect(() => {
    if (!isRouteErrorResponse(error) && !isApiProblem(error)) {
      reportError(error);
    }
  }, [error]);
  if (import.meta.env.DEV && !isRouteErrorResponse(error)) {
    console.error(error);
  }

  return <RouteError supportCode={isApiProblem(error) ? error.supportCode : undefined} onRetry={() => window.location.reload()} />;
}
